export const appStoreLink = 'https://apps.apple.com/no/app/formue/id1468084673';
export const appStoreDeepLink =
  'itms-apps://apps.apple.com/id/app/formue/id1468084673';
export const playStoreLink =
  'https://play.google.com/store/apps/details?id=no.formue.formue.no';
